import React from 'react';
import styled from 'styled-components';
import { breakpoint } from '../../../../admin/javascript/contract/duck/grid';

export default class Tab extends React.Component {
  constructor(props) {
    super(props);
  }

  render = () => {
    return this.props.mobile ? this.mobileTab() : this.desktopTab();
  };

  desktopTab = () => {
    return (
      <li
        className={`tab ${this.props.type} ${
          this.props.active ? 'active' : ''
        }`}
        onClick={this.handleClick}
      >
        {this.props.icon && (
          <img
            src={this.props.icon}
            className="tab-icon"
            height="16px"
            width="16px"
            alt=""
          />
        )}{' '}
        {this.props.mobile_name && (
          <MobileNameWrapper className="tab-name">
            {this.props.mobile_name}
          </MobileNameWrapper>
        )}
        <DesktopNameWrapper
          className="tab-name"
          hideOnMobile={this.props.mobile_name}
        >
          {this.props.name}
        </DesktopNameWrapper>
        {typeof this.props.counter !== 'undefined' && (
          <span className="counter">{this.props.counter}</span>
        )}
      </li>
    );
  };

  mobileTab = () => {
    return (
      <li
        className={`item ${this.props.active ? 'active' : ''}`}
        onClick={this.handleClick}
      >
        <input
          type="radio"
          id={`${this.props.class_name}-option-${this.props.value}`}
          data-value={this.props.value}
          data-name={this.props.name}
          checked={this.props.active}
        />
        <label htmlFor={`${this.props.class_name}-option-${this.props.value}`}>
          {' '}
          {this.props.mobile_name
            ? this.props.mobile_name
            : this.props.name}{' '}
          {typeof this.props.counter !== 'undefined' && (
            <span className="counter">{this.props.counter}</span>
          )}{' '}
        </label>
      </li>
    );
  };

  handleClick = () => {
    this.props.handleTabChange(
      this.props.index,
      this.props.type,
      this.props.value,
      this.props.name
    );
  };
}

const DesktopNameWrapper = styled.div`
  display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'block')};
  ${breakpoint.m`
    display: inline-block;
  `};
`;

const MobileNameWrapper = styled.div`
  display: none !important;
  ${breakpoint.df`
    display: block !important;
  `};
  ${breakpoint.m`
    display: none !important;
  `};
`;



// WEBPACK FOOTER //
// ./app/javascript/common/components/tab.js